"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.createId = exports.addScrollListener = void 0;
exports.debounce = debounce;
exports.unsubscribe = exports.subscribe = exports.resetId = exports.removeScrollListener = void 0;
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _global = _interopRequireDefault(require("./global"));
/* eslint-disable func-names, prefer-arrow-callback, no-shadow */
/* eslint-disable guard-for-in, no-restricted-syntax, no-use-before-define */

var canUseDOM = !!(_global.default && _global.default.document && _global.default.document.createElement);

/**
 * If we aren't in a browser environment then all of the
 * exports from this module should just be no-ops.
 */
function noop() {}

/**
 * By far the most ideal time (performance wise) to check
 * whether elements are present in the viewport during idle
 * time... this way we can ensure that no DOM writes (instigated
 * by us, or by whichever framework we are using) are happening
 * and we can avoid a forced syncronous layout. This
 * `requestIdleCallback` API has pretty poor browser support,
 * so we need to polyfill it - it's appropriate to just use
 * a sync function in it's place, so long as we keep the calling
 * function asyncronous.
 */
var requestIdleCallback = _global.default && _global.default.requestIdleCallback ? _global.default.requestIdleCallback : function (fn) {
  fn();
};

/**
 * Debounces a function on the trailing edge of an interval.
 * This is intended to be functional, so there's
 * no need to take context into account.
 *
 * Arguments may be passed to the debounced function.
 *
 * @param {Function} the function to debounce
 * @param {Integer} the timeout length (in ms)
 *
 * @returns {Function} the debounced function
 */
function debounce(fn, ms) {
  var timeout;
  return function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeout);
    var cb = args.length ? () => fn(...args) : fn;
    timeout = (0, _setTimeout2.default)(() => requestIdleCallback(cb), ms);
  };
}

/**
 * Retrieve the dimensions of the visible viewport.
 */
function getViewportDimensions() {
  return {
    innerWidth: _global.default.innerWidth || _global.default.document.documentElement.clientWidth,
    innerHeight: _global.default.innerHeight || _global.default.document.documentElement.clientHeight
  };
}

/**
 * Determine whether an element is visible in the viewport.
 *
 * @param {Object} viewport x and y dimensions.
 * @param {DOMElement}
 *
 * @returns {Bolean} whether the element is visible.
 */
function isVisible(viewport, element) {
  var {
    bottom,
    left,
    right,
    top
  } = element.getBoundingClientRect();
  /**
   * So far as I can reason the simplest way to do this is to determine that
   * either one of the edges is within the viewport.
   */
  return (bottom >= 0 && bottom <= viewport.innerHeight || top >= 0 && top <= viewport.innerHeight) && (right >= 0 && right <= viewport.innerWidth || left >= 0 && left <= viewport.innerWidth);
}

// Counter for generated IDs
var idCount = 0;

/**
 * Reset the ID count; must be called before rendering each server request
 * so that server side rendered IDs match client side generated ones.
 */
var resetId = () => {
  idCount = 0;
};

/**
 * Since components which which are subscribed to visibility updates
 * are indexed using ids it's practical to export a function that
 * can be used to create uids. With a six char hex string there
 * is no chance of collision, and this method should
 * also shouldn't break server side rendering.
 *
 * NOTE: In most cases it would also be possible to use a hash of
 * the image source to accomplish the same thing, but this won't
 * always work since the same image could appear twice in
 * a document.
 *
 * @return {String} a per instance uid.
 */
exports.resetId = resetId;
var createId = () => {
  var _context;
  return (0, _slice.default)(_context = "00000".concat((idCount++).toString(16))).call(_context, -6);
};
exports.createId = createId;
var {
  addScrollListener,
  removeScrollListener,
  subscribe,
  unsubscribe
} = function () {
  if (!canUseDOM) {
    return {
      subscribe: noop,
      unsubscribe: noop,
      addScrollListener: noop,
      removeScrollListener: noop
    };
  }

  /**
   * We need to keep a cache of all of the elements that are
   * should be subscribe to viewport visibility updates.
   * When any of these elements become visible, inside the viewport
   * call the supplied callback function and unsubcribe the element.
   */
  var listeners = {};

  /**
   * Add an element (by id) to the set of elements that are
   * deffering image loading. The supplied function will be called
   * whenever the element is determined to be inside the visible
   * viewport and the listener will automatically be removed.
   *
   * @param {DOMElementId} id
   * @param {Function}
   */
  function subscribe(id, fn) {
    listeners[id] = fn;
    loopSubscribers();
  }

  /**
   * Removes an element (by id) from the set of elements that
   * for which image loading is being deffered, this is called
   * internally in response to the handler having been called,
   * or externally in response to an element being removed from
   * the DOM.
   *
   * @param {DOMElementId} id
   */
  function unsubscribe(id) {
    delete listeners[id];
  }

  /**
   * Add an event listener (scroll listener) to a container
   * element (id) so that scrolling of that element will
   * trigger a check against the viewport for which elements
   * have come into view. This is necessary because the scroll
   * event doesn't bubble to the document.
   *
   * @param {DOMElementId} id
   */
  function addScrollListener(id) {
    var element = _global.default.document.getElementById(id);
    if (element) element.addEventListener('scroll', loopSubscribers, {
      passive: true
    });
  }

  /**
   * Remove an event listener (scroll listener) for a
   * container.
   *
   * @param {DOMElementId} id
   */
  function removeScrollListener(id) {
    var element = _global.default.document.getElementById(id);
    if (element) element.removeEventListener('scroll', loopSubscribers);
  }
  var loopSubscribers = debounce(function () {
    var viewportDimensions = getViewportDimensions();
    for (var id in listeners) {
      var element = _global.default.document.getElementById(id);

      /**
       * If the element doesn't exist the listener needs to be removed.
       * TODO: I'm not sure this callback is required.
       */
      if (!element) {
        unsubscribe(id);
        return;
      }

      /**
       * If the element is visible in the viewport then we need to
       * call the it's callback function and remove it from
       * the cache.
       */
      if (isVisible(viewportDimensions, element)) {
        listeners[id]();
        unsubscribe(id);
      }
    }
  }, 16);

  /**
   * Most mobile browsers fire a resize event on scroll,
   * so it might be worth checking that the viewport
   * size has actually changed before calling
   * `loopSubscribers` in response to a resize.
   *
   * NOTE: We use passive event listeners to improve scroll performance
   * since we won't actually be cancelling the scroll event - this perf
   * improvements are noticable on mobile. see;
   * https://medium.com/@devlucky/about-passive-event-listeners-224ff620e68c#.5xdjq9p2i
   */
  if (_global.default.addEventListener) {
    _global.default.addEventListener('scroll', loopSubscribers, {
      passive: true
    });
    _global.default.addEventListener('resize', loopSubscribers, false);
  }
  return {
    subscribe,
    unsubscribe,
    addScrollListener,
    removeScrollListener
  };
}();
exports.unsubscribe = unsubscribe;
exports.subscribe = subscribe;
exports.removeScrollListener = removeScrollListener;
exports.addScrollListener = addScrollListener;